import { TrendingUp, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const PRICING_TIERS = [
  {
    id: "pequena",
    tier: "Clínica pequeña",
    title: "Orden inicial",
    price: "Desde 800",
    priceSuffix: "€ + IVA",
    desc: "Ideal para un único centro con usos limitados de IA y necesidad de establecer un orden y control inicial.",
    features: ["Diagnóstico inicial completo", "Mapa de herramientas IA", "Identificación de riesgos prioritarios", "Recomendaciones base documentadas", "Informe ejecutivo de hallazgos"],
    featured: false,
    ctaText: "Pedir valoración",
  },
  {
    id: "mediana",
    tier: "Clínica mediana",
    title: "Auditoría completa",
    price: "Desde 1.200",
    priceSuffix: "€ + IVA",
    desc: "Para clínicas con marketing automatizado, simuladores, flujos con imágenes o varios perfiles implicados.",
    features: ["Auditoría legal ampliada", "Matriz de riesgos detallada", "Revisión de consentimientos y cláusulas", "Protocolos internos documentados", "Revisión de marketing con IA", "Checklist de supervisión humana"],
    featured: true,
    ctaText: "Solicitar diagnóstico",
  },
  {
    id: "grupo",
    tier: "Grupo de clínicas",
    title: "Gobernanza IA",
    price: "A medida",
    priceSuffix: "",
    desc: "Para estructuras multi-centro o entornos con fuerte dependencia tecnológica y necesidad de gobernanza común.",
    features: ["Modelo de implantación por sedes", "Priorización y hoja de ruta", "Marco de gobernanza de IA", "Política corporativa de IA", "Seguimiento y revisión posterior"],
    featured: false,
    ctaText: "Consultar presupuesto",
  },
];

export function PricingSection({ scrollToSection }) {
  return (
    <section id="precios" className="section-darker" data-testid="pricing-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="eyebrow mb-4 inline-flex">
            <TrendingUp className="w-4 h-4" />
            <span>Inversión</span>
          </span>
          <h2 className="section-title mt-4">Precios orientativos</h2>
          <p className="section-subtitle mx-auto mt-4">
            El coste final depende del número de centros, herramientas utilizadas, complejidad de los flujos y alcance del trabajo solicitado.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {PRICING_TIERS.map((tier) => (
            <div key={tier.id} className={`pricing-card ${tier.featured ? "featured" : ""}`} data-testid={`pricing-card-${tier.id}`}>
              {tier.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-blue-500 text-white text-xs font-bold uppercase rounded-full">
                  Más habitual
                </div>
              )}
              <div className="pricing-tier">{tier.tier}</div>
              <h3 className="pricing-title">{tier.title}</h3>
              <div className="pricing-price">{tier.price} {tier.priceSuffix && <span>{tier.priceSuffix}</span>}</div>
              <p className="pricing-desc">{tier.desc}</p>
              <ul className="pricing-features">
                {tier.features.map((f) => (
                  <li key={f}><Check className="w-4 h-4" />{f}</li>
                ))}
              </ul>
              <Button
                onClick={() => scrollToSection('diagnostico')}
                variant={tier.featured ? "default" : "outline"}
                className={`${tier.featured ? "btn-primary" : "btn-secondary"} w-full`}
                data-testid={`pricing-cta-${tier.id}`}
              >
                {tier.ctaText}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
